var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3211_15973)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9294 17.905C23.0265 17.2895 20.8544 17.7374 19.3431 19.2487L15.1004 23.4914C12.9526 25.6392 12.9526 29.1217 15.1004 31.2695C17.2483 33.4174 20.7307 33.4174 22.8786 31.2695L27.1213 27.0269C28.6326 25.5156 29.0805 23.3435 28.465 21.4405L25.3535 24.552L25.3181 24.5167C25.2271 24.6541 25.121 24.7845 24.9999 24.9056L20.7573 29.1482C19.781 30.1245 18.1981 30.1245 17.2218 29.1482C16.2454 28.1719 16.2454 26.589 17.2218 25.6127L21.4644 21.37C21.5855 21.249 21.7159 21.1429 21.8533 21.0518L21.818 21.0165L24.9294 17.905Z",
    fill: "#A79FBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7783 22.7842L28.8892 26.6733L28.5356 27.0269L25.0706 30.4919C26.9736 31.1074 29.1456 30.6595 30.6569 29.1482L34.8996 24.9055C37.0475 22.7577 37.0475 19.2753 34.8996 17.1274C32.7517 14.9795 29.2693 14.9795 27.1214 17.1274L22.8788 21.37C21.3674 22.8813 20.9195 25.0534 21.5351 26.9564L25.0001 23.4913L25.3536 23.1378L29.2427 19.2487C30.219 18.2724 31.802 18.2724 32.7783 19.2487C33.7546 20.225 33.7546 21.8079 32.7783 22.7842Z",
    fill: "#A79FBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3211_15973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 12.2383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipLinkIcon);
export default __webpack_public_path__ + "static/media/Clip_link_icon.984eb17e16cd7830969a5848ab75828a.svg";
export { ForwardRef as ReactComponent };